import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Select,
  MenuItem,
  Typography,
  InputLabel,
  FormControl,
  Box,
  TextareaAutosize,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/loader/actions";
import { showSnackbar } from "../../../redux/snackbar/actions";
import { encryptAES, decryptAES } from "../../../utils";

const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  closeButton: {
    marginLeft: "auto",
  },
});

const VendorCreation = ({ open, onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      mobilenumber: "",
      emp_id: "",
      role: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Name is required")
        .min(3, "Name should be at least 3 characters"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      mobilenumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
        .required("Mobile number is required"),
      emp_id: Yup.string().required("Employee ID is required"),
      role: Yup.string().required("Role is required"),
    }),
    // onSubmit: handleSubmit,
  });
  const purchaseOptions = ["Transactional SMS", "Transactional Whatsapp"];
  const communicationOptions = ["SMS", "Whatsapp", "Email"];

  const [validityType, setValidityType] = useState("");

  const handleValidityChange = (event) => {
    setValidityType(event.target.value);
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle disableTypography className={classes.dialogTitleContainer}>
        {/* {mode === "edit" ? "Edit User" : "Add User"} */}Count Adjustments
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={12} md={4}>
            <Autocomplete
              fullWidth
              multiple
              options={purchaseOptions}
              value={formik.values.frequency}
              onChange={(e, value) => formik.setFieldValue("frequency", value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sourced For"
                  name="frequency"
                  placeholder="Select Purchase Category"
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.frequency && Boolean(formik.errors.frequency)
                  }
                  // helperText={
                  //   formik.touched.frequency ? formik.errors.frequency : " "
                  // }
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Autocomplete
              fullWidth
              multiple
              options={communicationOptions}
              value={formik.values.frequency}
              onChange={(e, value) => formik.setFieldValue("frequency", value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Communication Type"
                  name="frequency"
                  placeholder="Select Communication Type"
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.frequency && Boolean(formik.errors.frequency)
                  }
                  // helperText={
                  //   formik.touched.frequency ? formik.errors.frequency : " "
                  // }
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <TextField
              name="mobilenumber"
              label="Adjusted Count"
              variant="outlined"
              //   disabled={mode === "edit"}
              fullWidth
              value={formik.values.mobilenumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.mobilenumber &&
                Boolean(formik.errors.mobilenumber)
              }
              helperText={
                formik.touched.mobilenumber && formik.errors.mobilenumber
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <TextField
              name="address"
              label=" Reason for Adjustment"
              variant="outlined"
              fullWidth
              multiline
              minRows={1}
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.address && Boolean(formik.errors.address)}
              helperText={formik.touched.address && formik.errors.address}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box m={2}>
          <Button
            variant="contained"
            color="primary"
            className={classes.animatedButton}
            onClick={formik.handleSubmit}
          >
            {/* {mode === "edit" ? "Update" : "Add User"} */}
            Submit
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default VendorCreation;
